import React from "react";

const ProductDescription = ({ data }) => {
  return (
    <div className="list-item max-w-[1240px] m-auto font-medium text-[14px] mt-[24px] leading-[28px]">
      <ul className="">
        <li>{data}</li>
      </ul>
    </div>
  );
};

export default ProductDescription;
